module.exports = __webpack_public_path__ + "img/thzg.99bad808.png";